export enum MohAgreementHolderSource {
  Practice = 'practice',
  Practitioner = 'practitioner',
}

export const MOH_AGREEMENT_HOLDER_SOURCE_LABEL_MAP: Record<
  MohAgreementHolderSource,
  string
> = {
  [MohAgreementHolderSource.Practice]: 'Practice',
  [MohAgreementHolderSource.Practitioner]: 'Practitioner',
};

export interface IMohAgreementHolder {
  source: MohAgreementHolderSource;
  payeeNumber: string;
  agreementNumber: string;
  agreementHolderName: string;
}
